export default __webpack_public_path__ + "static/2-849b9316068dbb7c771bc219bcb67045.png";